import * as z from 'zod'; 

export const MediaFormat = z.object({
  url: z.string(),
  width: z.number(),
  height: z.number(),
  mime: z.string(),
});

export const MediaVariants = z.object({
  width: z.number(),
  height: z.number(),
  src: z.string(),
  webp: z.string(),
  avif: z.string().optional(),
});

export type MediaVariantsType = z.infer<typeof MediaVariants>;

export const Media = z.object({
  id: z.number(),
  documentId: z.string(),
  name: z.string(),
  url: z.string(),
  alternativeText: z.string().nullable(),
  caption: z.string().nullable(),
  width: z.number().nullable(),
  height: z.number().nullable(),
  mime: z.string().optional(),
  hash: z.string().optional(),
  updatedAt: z.string().optional(),
  formats: z.record(z.string(), MediaFormat).nullable().optional(),
  variants: MediaVariants.optional(),
});

export type MediaType = z.infer<typeof Media>;

export const CTA = z.object({
  title: z.string(),
  url: z.string(),
});

export const SEO = z.object({
  metaTitle: z.string(),
  metaDescription: z.string(),
  canonicalLink: z.string().nullish(),
  metaRobotsTag: z.enum([
    'index, follow',
    'noindex, follow',
    'index, nofollow',
    'noindex, nofollow',
    'noodp'
  ]).nullable().optional(),
  breadcrumbTitle: z.string().nullish(),
});

export const Meta = z.object({
  pagination: z.object({
    page: z.number(),
    pageSize: z.number(),
    pageCount: z.number(),
    total: z.number(),
  })
});

export type MetaType = z.infer<typeof Meta>;

export const Localization = z.object({
  id: z.number(),
  documentId: z.string(),
  locale: z.string(),
  slug: z.string().nullish(),
});

export type LocalizationType = z.infer<typeof Localization>;